<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <article class="form-heading title-section form-section flex">
            <h1 class="form-title" style="width: 345px;">Your Premium Proposal</h1>
            <img
              src="../../../public/assets/images/financial.png"
              class="title-section-img form-title-img financial-section-img"
              alt="background image"
            >
          </article>
          <article class="input-section form-section">
            <div class="form-inline mb-3">
              <label class="mr-2 label-price">
                <h5 class="strong w-100">Limits of Coverage:</h5>
              </label>
              <h5 class="strong">{{coverage}}</h5>
            </div>
            <div class="form-inline">
              <label class="mr-2 label-price">
                <h5 class="w-100 font-weight-bold">Premium Due:</h5>
              </label>
              <h5 class="font-weight-bold">${{(state.premium).toFixed(2)}}</h5>
            </div>
            <h5 class="font-weight-bold mt-3">Optional Coverages:</h5>

            <div class="radio orep-radio-wrapper solo-checkbox" style="margin-top: 20px; margin-bottom: 20px">
              <label>
                <input
                    type="checkbox"
                    name="cyberTechnologyCoverage"
                    class="orep-radio"
                    v-model="axApplication.cyberTechnologyCoverage"
                    @change="getPremium()"
                >
                <span class="radio-span solo-checkbox-span" style="text-transform:uppercase;">
                  $100,000 of
                  <a href="https://orep.org/100K-cyber-coverage" target="_blank" class="coverage-link">
                    Cyber / Technology Security Coverage
                  </a>
                  (HIGHLY RECOMMENDED) :
                  <strong style="font-weight: bold !important; font-family: Roboto, sans-serif; color: #046085;">
                    {{ axApplication.cyberTechnologyCoverage ? '$' + state.premiumCyberTechnologyCoverage.toFixed(2) : '' }}
                  </strong>
                </span>

              </label>
            </div>

            <div class="radio orep-radio-wrapper solo-checkbox" style="margin-top: 20px; margin-bottom: 20px">
              <label>
                <input
                  type="checkbox"
                  name="traineeCoverage"
                  class="orep-radio"
                  v-model="axApplication.traineeCoverage"
                  @change="getPremium()"
                >
                <span class="font-weight-bold  radio-span solo-checkbox-span" style="text-transform:uppercase">
                  APPRAISER TRAINEE COVERAGE: <strong>{{axApplication.traineeCoverage ? '$'+(state.premiumTraineeCoverage).toFixed(2) : ''}}</strong>
                </span>

              </label>
              <label>
                  <span class=" orep-radio  radio-span solo-checkbox-span" style="text-transform:uppercase">
                      Adds Appraiser Trainee to coverage when performing services on behalf of the Named Insured.
                  </span>
              </label>
            </div>

            <div class="radio orep-radio-wrapper solo-checkbox" style="margin-top: 20px">
              <label>
                <input
                  type="checkbox"
                  name="mgmtCoverage"
                  class="orep-radio"
                  v-model="axApplication.mgmtCoverage"
                  @change="getPremium()"
                >
                <span class="font-weight-bold  radio-span solo-checkbox-span" style="text-transform:uppercase">
                  REAL ESTATE APPRAISAL MANAGEMENT COMPANY EXTENSION: <strong>{{axApplication.mgmtCoverage ? '$'+(state.premiumMgmtCoverage).toFixed(2) : ''}}</strong>
                </span>
              </label>
              <label>
                  <span class=" orep-radio  radio-span solo-checkbox-span" style="text-transform:uppercase">
                  Extends coverage to the Real Estate Appraisal Management Company when it is named or joined as a party in a Claim brought against the Named Insured.
                  </span>
              </label>
            </div>
            <div class="form-inline mt-4">
              <label class="mr-2 label-price">
                <h5 class="w-100 strong">Total Premium:</h5>
              </label>
              <h5 class="strong">${{total.toFixed(2)}}</h5>
            </div>
            <div class="form-inline mt-4" v-show="axApplication.customer.state == 'WV' || axApplication.customer.state == 'CT' || axApplication.customer.state == 'NY' || axApplication.customer.state == 'FL' || axApplication.customer.state == 'NJ' || axApplication.customer.state == 'MA'">
              <label class="mr-2 label-price">
                <h5 class="w-100 strong">State Tax:</h5>
              </label>
              <h5 v-if = "state.stateTax == '0'" class="strong">Agent to Calculate</h5>
              <h5 v-else class="strong">${{ (state.stateTax).toFixed(2) }}</h5>
<!--              <div class="form-inline mt-4" v-show="axApplication.customer.state == 'CT' || axApplication.customer.state == 'NY' || axApplication.customer.state == 'FL' || axApplication.customer.state == 'NJ' || axApplication.customer.state == 'MA'">-->
<!--                <label>-->
<!--                  <h5 class="w-100 strong">Tax will be between 5-10% depending on your County. Your Agent will calculate Tax Due After Application is Submitted. </h5>-->
<!--                </label>-->
<!--              </div>-->
            </div>
            <div class="form-inline mt-4" v-show="axApplication.customer.state == 'WV' || axApplication.customer.state == 'CT' || axApplication.customer.state == 'NY' || axApplication.customer.state == 'FL' || axApplication.customer.state == 'NJ' || axApplication.customer.state == 'MA' || axApplication.customer.state == 'KY'">
              <label class="mr-2 label-price">
                <h5 class="w-100 strong">Total Premium + Tax:</h5>
              </label>
              <h5 class="strong">${{(state.totalPremium).toFixed(2)}}</h5>
            </div>
          </article>
          <article class="d-flex form-heading title-section form-section">
            <p class="form-title text-center m-0 w-100" style="font-size: 35px;">
              PLEASE READ
            </p>
          </article>
          <article class="input-section form-section">
            <p class="text-center font-weight-bold" style="text-decoration: underline;font-size: 20px;">
              This Policy Includes $200,000 of Discrimination Claim Coverage
            </p>
            <ol class="pl-0">
              <li class="mb-3">
                A standard Deductible of <span class="font-weight-bold" style="text-decoration: underline;">$500 per claim / $1,000 annual aggregate</span> will be included in each policy,
                but the Deductible is Waived pursuant to the insured’s participation in the risk management program of the OREP Risk Purchasing Group (RPG).
              </li>
              <li class="mb-3">
                A Risk Purchasing Group Member Fee for the OREP RPG will be charged in addition to the Premium listed above.
              </li>
              <li>
                The premiums listed above are subject to change based on carrier filings and should not be considered final until written
                confirmation is obtained from the carrier.
              </li>
            </ol>
          </article>

        </div>
        <div class="col-md-12">
          <form action>
            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">FRAUD WARNINGS
              </h1>
              <img
                  src="../../../public/assets/images/notepad.png"
                  class="title-section-img form-title-img ops-section-img"
                  alt="background image"
              >
            </article>

            <article class="input-section form-section">
              <label class="orep-label">   <strong>NOTICE TO ALL PROSPECTIVE INSUREDS: </strong></label>
              <p>
                Any person who knowingly, and with intent to defraud any insurance company or other person, files an application for
                insurance or statement of claim containing any materially false information, or, for the purpose of misleading, conceals
                information concerning any fact material thereto, may commit a fraudulent insurance act which is a crime and subjects such
                person to criminal and civil penalties in many states.              </p>

              <label class="orep-label">   <strong>NOTICE TO PROSPECTIVE INSUREDS IN: </strong></label>

              <p>
                <strong>Colorado :</strong>
                It is unlawful to knowingly provide false, incomplete or misleading facts or information to an insurance company for the
                purpose of defrauding or attempting to defraud the company. Penalties may include imprisonment, fines, denial of insurance
                and civil damages. Any insurance company or agent of an insurance company who knowingly provides false, incomplete,
                or misleading facts or information to a policyholder or claimant for the purpose of defrauding or attempting to defraud the
                policyholder or claimant with regard to a settlement or award payable for insurance proceeds shall be reported to the
                Colorado Division of Insurance within the Department of Regulatory Agencies.              </p>
              <p>
                <strong>California :</strong>
                For your protection, California law requires the following to appear on this form:  Any person who knowingly presents false or fraudulent information to obtain or amend insurance coverage or to make a claim for the payment of a loss is guilty of a crime and may be subject to fines and confinement in state prison.             </p>
              <p>
                <strong>Alabama, Arkansas, District of Columbia, Louisiana, New Mexico, Rhode Island, West Virginia : </strong>
                Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false
                information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison.
              </p>
              <p>
                <strong>Florida : </strong>
                Any person who knowingly and with intent to injure, defraud or deceive any insurer files a statement of claim or an application
                containing any false, incomplete or misleading information is guilty of a felony of the third degree.
              </p>
              <p>
                <strong>Kansas : </strong>
                Any person who, knowingly and with intent to defraud, presents, causes to be presented or prepares with knowledge or
                belief that it will be presented to or by an insurer, purported insurer, broker or agent thereof, any written, electronic,
                electronic impulse, facsimile, magnetic, oral, or telephonic communication or statement as part of, or in support of, an
                application for the issuance of, or the rating of an insurance policy for personal or commercial insurance, or a claim for
                payment or other benefit pursuant to an insurance policy for commercial or personal insurance which such person knows to
                contain materially false information concerning any fact material thereto; or conceals, for the purpose of misleading,
                information concerning any fact material thereto commits a fraudulent insurance act.              </p>
              <p>
                <strong>Kentucky : </strong>
                Any person who knowingly and with intent to defraud any insurance company or other person files an application for
                insurance containing any materially false information or conceals, for the purpose of misleading, information concerning any
                fact material thereto commits a fraudulent insurance act, which is a crime.              </p>
              <p>
                <strong>Maine, Tennessee, Virginia, Washington : </strong>
                It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of
                defrauding the company. Penalties may include imprisonment, fines, and denial of insurance benefits.              </p>
              <p>
                <strong>Maryland : </strong>
                Any person who knowingly or willfully presents a false or fraudulent claim for payment of a loss or benefit or who knowingly
                or willfully presents false information in an application for insurance is guilty of a crime and may be subject to fines and
                confinement in prison.              </p>
              <p>
                <strong>Minnesota : </strong>
                A person who submits an application or files a claim with intent to defraud or helps commit a fraud against an insurer is
                guilty of a crime.              </p>
              <p>
                <strong>New Jersey : </strong>
                Any person who includes any false or misleading information on an application for an insurance policy is subject to criminal
                and civil penalties.              </p>
              <p>
                <strong>New York: </strong>
                Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information, or conceals for the purpose of misleading, information concerning any fact material thereto, commits a fraudulent insurance act, which is a crime, and shall also be subject to a civil penalty not to exceed five thousand dollars and the stated value of the claim for each such violation.
              </p>
              <p>
                <strong>Ohio : </strong>
                Any person who, with intent to defraud or knowing that he/she is facilitating a fraud against an insurer, submits an application
                or files a claim containing a false or deceptive statement is guilty of insurance fraud.              </p>
              <p>
                <strong>Oregon : </strong>
                Any person who knowingly, and with intent to defraud any insurance company or other person, files an
                application for insurance or statement of claim containing any materially false information, or,
                for the purpose of misleading, conceals information concerning any fact material thereto, may commit a
                fraudulent insurance act which may be a crime and may subject such person to criminal and civil penalties.              </p>
              <p>
                <strong>Oklahoma : </strong>
                WARNING: Any person who knowingly, and with intent to injure, defraud or deceive any insurer, makes any claim for the
                proceeds of an insurance policy containing any false, incomplete or misleading information is guilty of a felony.              </p>
              <p>
                <strong>Pennsylvania : </strong>
                Any person who knowingly and with intent to defraud any insurance company or other person files an application for
                insurance or statement of claim containing any materially false information or conceals for the purpose of misleading,
                information concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such
                person to criminal and civil penalties.              </p>
              <p>
                <strong>Vermont : </strong>
                Any person who knowingly presents a false statement in an application for insurance may be guilty of a criminal offense
                and subject to penalties under state law.              </p>
              <h5 class="font-weight-bold" style="text-align: center">
                DISCLAIMER</h5>
              <h5 class="font-weight-bold">
                COMPLETION OF THIS FORM DOES NOT BIND COVERAGE. THE APPLICANT AND FIRM ACCEPTS NOTICE THAT ANY POLICY
                ISSUED WILL APPLY ON A “CLAIMS-MADE” BASIS. THE APPLICANT AND FIRM ACCEPTS NOTICE THAT THEY ARE
                REQUIRED TO PROVIDE WRITTEN NOTIFICATION TO THE COMPANY OF ANY CHANGES TO THIS APPLICATION THAT MAY
                HAPPEN BETWEEN THE SIGNATURE DATE BELOW AND ANY PROPOSED EFFECTIVE DATE. THE APPLICATION MUST BE
                SIGNED BY AN ACTIVE OWNER, PARTNER, PRINCIPAL, OFFICER, OR MEMBER OF THE APPLICANT.             </h5>

              <p>
                The undersigned is authorized by, and acting on behalf of, the Applicant and represents that all statements and particulars
                herein are true, complete and accurate to the best of their knowledge and that there has been no suppression or misstatements
                of fact and agrees that this application shall be the basis of, and becomes part of, the Applicant’s professional liability coverage.
              </p>
              <p>
                I understand that the final premium will be rounded to the nearest whole dollar. I declare that all statements and particulars herein are true, complete and accurate and that there has been no suppression or misstatements of fact and agree that this application shall be the basis of, and becomes a part of, my Professional Liability coverage.
              </p>
            </article>
            <article class="input-section form-heading form-section review-sign">
              <div class="row mr-0 ml-0">
                <p>
                  <strong>Consent to Electronic Signature: </strong>
                  I Wish to Sign Electronically. By typing my name below, I hereby sign my application and consent to the use of electronic signature for the purposes of this insurance application. (Please email <a href="mailto:info@orep.org" target="_top">info@orep.org</a> if you do not consent to Electronic Signature.)
                </p>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Please print your name:</p>
                    <input
                        type="text"
                        class="orep-text-input notice-input"
                        placeholder="Type Your Name"
                        name="nameForFraudWarning"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        v-model="axApplication.nameForFraudWarning"
                    >
                    <span
                        v-show="errors.has('nameForFraudWarning')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('nameForFraudWarning') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Title:</p>
                    <input
                        type="text"
                        class="orep-text-input notice-input"
                        placeholder="Type Title"
                        name="titleForFraudWarning"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        v-model="axApplication.titleForFraudWarning"
                    >
                    <span
                        v-show="errors.has('titleForFraudWarning')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('titleForFraudWarning') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Signature:</p>
                    <input
                        type="text"
                        class="orep-text-input notice-input"
                        placeholder="Type Your Name to Sign"
                        name="appraiserPrincipleEsignature"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        v-model="axApplication.appraiserPrincipleEsignature"
                    >
                    <span
                        v-show="errors.has('appraiserPrincipleEsignature')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('appraiserPrincipleEsignature') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Date:</p>
                    <input
                        type="date"
                        class="orep-text-input notice-input text-center"
                        :value="formattedCurrentDate()"
                        disabled
                    >
                  </section>
                </div>
              </div>
            </article>
            <!--            <article class="form-heading form-section review-sign" v-if="axApplication.customer.state == 'MO' || axApplication.customer.state == 'WY' ">-->
            <!--              <div class="row">-->
            <!--                <h5 class="mt-4 mb-0 mx-5 font-weight-bold">-->
            <!--                  <strong>FOR Missouri and Wyoming Applicants Only: </strong></h5>-->
            <!--                <h6 class="mt-4 mb-0 mx-5 font-weight-bold">-->
            <!--                  PLEASE ACKNOWLEDGE AND SIGN THE FOLLOWING DISCLOSURE TO YOUR APPLICATION FOR INSURANCE:             </h6>-->

            <!--                <h6 class="mt-4 mb-0 mx-5 font-weight-bold">-->
            <!--                  THE APPLICANT UNDERSTANDS AND ACKNOWLEDGES THAT THE POLICY FOR WHICH IT IS APPLYING CONTAINS A-->
            <!--                  DEFENSE WITHIN LIMITS PROVISION WHICH MEANS THAT CLAIMS EXPENSES WILL REDUCE THE POLICY’S LIMITS-->
            <!--                  OF LIABILITY AND MAY EXHAUST THEM COMPLETELY. SHOULD THAT OCCUR, THE APPLICANT SHALL BE LIABLE-->
            <!--                  FOR ANY FURTHER CLAIMS EXPENSES AND DAMAGES.             </h6>-->
            <!--                <div class="col-md-6">-->
            <!--                  <section class="notice-form mt-3">-->
            <!--                    <p class="notice-form-date">Please print your name:</p>-->
            <!--                    <input-->
            <!--                      type="text"-->
            <!--                      class="orep-text-input notice-input"-->
            <!--                      placeholder="Type Your Name to Sign"-->
            <!--                      name="nameForStateMoWy"-->
            <!--                      v-validate="axApplication.customer.state == 'WY' || axApplication.customer.state == 'MO' ? 'required': ''"-->
            <!--                      @input="validateBeforeSubmit()"-->
            <!--                      v-model="axApplication.nameForStateMoWy"-->
            <!--                    >-->
            <!--                    <span-->
            <!--                      v-show="errors.has('nameForStateMoWy')"-->
            <!--                      class="help is-danger form-errors text-danger"-->
            <!--                    >{{ errors.first('nameForStateMoWy') | filterText }}</span>-->
            <!--                  </section>-->
            <!--                </div>-->
            <!--                <div class="col-md-6">-->
            <!--                  <section class="notice-form mt-3">-->
            <!--                    <p class="notice-form-date">Title:</p>-->
            <!--                    <input-->
            <!--                      type="text"-->
            <!--                      class="orep-text-input notice-input"-->
            <!--                      placeholder="Type Title"-->
            <!--                      name="titleForStateMoWy"-->
            <!--                      v-validate="axApplication.customer.state == 'WY' || axApplication.customer.state == 'MO' ? 'required': ''"-->
            <!--                      @input="validateBeforeSubmit()"-->
            <!--                      v-model="axApplication.titleForStateMoWy"-->
            <!--                    >-->
            <!--                    <span-->
            <!--                      v-show="errors.has('titleForStateMoWy')"-->
            <!--                      class="help is-danger form-errors text-danger"-->
            <!--                    >{{ errors.first('titleForStateMoWy') | filterText }}</span>-->
            <!--                  </section>-->
            <!--                </div>-->
            <!--                <div class="col-md-6">-->
            <!--                  <section class="notice-form mt-3">-->
            <!--                    <p class="notice-form-date">Signature:</p>-->
            <!--                    <input-->
            <!--                      type="text"-->
            <!--                      class="orep-text-input notice-input"-->
            <!--                      placeholder="Type Your Name"-->
            <!--                      name="signatureForStateMoWy"-->
            <!--                      v-validate="axApplication.customer.state == 'WY' || axApplication.customer.state == 'MO' ? 'required': ''"-->
            <!--                      @input="validateBeforeSubmit()"-->
            <!--                      v-model="axApplication.signatureForStateMoWy"-->
            <!--                    >-->
            <!--                    <span-->
            <!--                      v-show="errors.has('signatureForStateMoWy')"-->
            <!--                      class="help is-danger form-errors text-danger"-->
            <!--                    >{{ errors.first('signatureForStateMoWy') | filterText }}</span>-->
            <!--                  </section>-->
            <!--                </div>-->
            <!--                <div class="col-md-6">-->
            <!--                  <section class="notice-form mt-3">-->
            <!--                    <p class="notice-form-date">Date:</p>-->
            <!--                    <input-->
            <!--                      type="date"-->
            <!--                      class="orep-text-input notice-input text-center"-->
            <!--                      :value="formattedCurrentDate()"-->
            <!--                      disabled-->
            <!--                    >-->
            <!--                  </section>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </article>-->
          </form>
        </div>
      </div>

    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'ax-application-2'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToOne()"></button>
              <button class="pagination-dots" @click="prev()"></button>
              <span class="pagination-dots pagination-current"></span>
              <button class="pagination-dots" @click="navigateToNext('ax-application-4')" :disabled="!state.pageThreeIsValid"></button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ax-application-5')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid">
              </button>
              <button
                class="pagination-dots"
                @click="navigateToNext('ax-application-6')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid ">
              </button>
            </article>
            <button
              type="submit"
              :disabled="!state.pageThreeIsValid"
              :class="{submitDisabled: !state.pageThreeIsValid}"
              class="next-btn mont spaced pull-right"
              @click="navigateToNext('ax-application-4')"
            >Next</button>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment/moment";

export default {
  name: "ax-application-3",
  computed: {
    axApplication() {
      return this.$store.state.axApplication.axApplication;
    },
    state() {
      return this.$store.state.axApplication;
    },
    errorMsg() {
      return this.$store.state.axApplication.errorMsg;
    },

    total() {
        let total = this.state.premium;
        if (this.axApplication.firstCoverage) {
          total += this.state.premiumFirstCoverage;
        }
        if (this.axApplication.traineeCoverage) {
          total += this.state.premiumTraineeCoverage;
        }
        if (this.axApplication.mgmtCoverage) {
          total += this.state.premiumMgmtCoverage;
        }
        if (this.axApplication.cyberTechnologyCoverage) {
          total += this.state.premiumCyberTechnologyCoverage;
        }
        return total;
      },
    coverage() {
      switch (this.axApplication.limitOfCoverage) {
        case '0.3M/0.6M':
          return '$300,000 / $600,000';
        case '0.5M/1M':
          return '$500,000 / $1,000,000';
        case '1M/1M':
          return '$1,000,000 / $1,000,000';
        default:
          return '$1,000,000 / $2,000,000';
      }
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    formattedCurrentDate() {
      return moment(this.axApplication.appraiserEsignatureDatetime).format('YYYY-MM-DD');
    },
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    getPremium() {
      // this.loading = true;
      this.$store.dispatch('axApplication/getPremium');
      this.validateBeforeSubmit();

    },

    prev() {
      this.$router.push({
        name: "ax-application-2"
      });
    },

    navigateToOne() {
      this.$router.push({
        name: "ax-application-1"
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageThreeIsValid = true;
          return;
        }
        this.state.pageThreeIsValid = false;
      });
    },
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
    this.getPremium();
  },
};
</script>

<style scoped>
  .strong {
    font-weight: bold;
  }
  table td {
    border: 1px solid black;
  }
  table tr > td:last-child {
    width: 100px;
  }
  table tr > td:first-child {
    padding: 10px;
  }
  .label-price {
    width: 220px;
  }
   .coverage-link {
     text-decoration: none;
     font-weight: bold;
     font-family: Roboto, sans-serif;
     color: #046085;
   }

  .coverage-link:hover {
    text-decoration: underline;
  }
</style>